import { breakpoints } from "../helpers/breakpoints";

export const bookNow = () => {
  const button = document.querySelectorAll("[js-open-booking-bar]")[0];
  if (button) {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      if (window.innerWidth < breakpoints.screen1024) {
        const mobileTarget = document.getElementById(
          "search-details-toggle"
        ) as HTMLElement;
        if (mobileTarget) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          mobileTarget.click();
          setTimeout(() => {
            const mobileTargetInner = document.getElementById(
              "availability-selection-accordion-button-2"
            ) as HTMLElement;
            if (mobileTargetInner) {
              mobileTargetInner.click();
            }
          }, 1000);
        }
      } else {
        const desktopTarget = document.getElementById(
          "availability-selection-tabs-button-2"
        ) as HTMLElement;
        if (desktopTarget) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          desktopTarget.click();
        }
      }
    });
  }
};
